import { FC, PropsWithChildren } from 'react';
import { Container } from 'inversify';
import { observer } from 'mobx-react-lite';

import { ContainerContext } from './ContainerContext';

export type ContainerProviderProps = PropsWithChildren<{
  container: Container;
}>;

/**
 * Provider for Inversify DI container
 * Makes the container available to all child components via context
 */
export const ContainerProvider: FC<ContainerProviderProps> = observer(({ children, container }) => {
  return <ContainerContext.Provider value={container}>{children}</ContainerContext.Provider>;
});

ContainerProvider.displayName = 'ContainerProvider';
